var opacityMap = {
    weak: 0.3,
    medium: 0.4,
    strong: 0.8,
};
export default (function (_a) {
    var opacity = _a.opacity;
    var value = opacity && opacityMap[opacity];
    return value ? "opacity: ".concat(value, ";") : "";
});
